import * as $ from 'jquery';
import 'slick-carousel';

//only prototype version:
// const check = $('.homepage-hero-carousel')
// if(check.length > 0){
// 	$('.header__shopping-count__notification')?.css("display", "none");
// }

class Homepagehero {

	init = () => {
		const carousels = Array.from(
			document.querySelectorAll<HTMLElement>('[data-carousel-style]')
		);

		carousels.forEach((carousel) => {
			this.slickInit(carousel);
		});
	};

	slickInit(el: HTMLElement) {

    const carouselTarget = el.querySelector('[data-carousel-target]');
    const autoplaySpeed = el.getAttribute('data-autoplay-speed') ? parseInt(el.getAttribute('data-autoplay-speed')!, 10) : 4000;


		const slickSettings: JQuerySlickOptions = {
			dots: true,
			// appendArrows: el.parentElement.querySelector('.slick-controls'),
			prevArrow: el.querySelector('[data-slick-prev]'),
			nextArrow: el.querySelector('[data-slick-next]'),
			// variableWidth: true,
			draggable: true,  
  			touchMove: true,
			swipe: true,
			adaptiveHeight: true,
			infinite: true,
			slidesToScroll: 1,
			// fade: true,
			autoplay: true,
			autoplaySpeed: autoplaySpeed,
			pauseOnHover: true,
		};
		const slick = $(carouselTarget).slick(slickSettings);

		const autoplayMouse = el.querySelector('[data-carousel-style]');

		autoplayMouse?.addEventListener('mouseenter', function(){
			slick.slick('slickPlay');
		});

		autoplayMouse?.addEventListener('mouseleave', function(){
			slick.slick('slickPause');
		});

		const pauseBtn = el.querySelector('[data-slick-pause]');

		if(pauseBtn) {
			pauseBtn.addEventListener('click', e => {
				const btn = <HTMLButtonElement>e.currentTarget;
				if(btn.classList.contains('pause')) {
					slick.slick('slickPlay');
					btn.classList.remove('pause');
				} else {
					slick.slick('slickPause');
					btn.classList.add('pause');
				}
			});
		}
	}
}

const HomepageheroInstance = new Homepagehero();
HomepageheroInstance.init();
